<script setup lang="ts">
// Tick labels for the timeline column, aligned with the bars below it.
import { useNode } from '../store'
import { useTicks } from '../ticks'

const node = useNode()
const ticks = useTicks()
</script>

<template>
    <div class="relative h-3.5 text-[10px] text-fg-3">
        <!-- a label this close to the right edge would sit on "now" and, centred, stick out of the row (horizontal scrollbar) -->
        <span
            v-for="(t, i) in ticks.filter((t) => t.x < 0.94)"
            :key="i"
            class="absolute top-0 -translate-x-1/2 whitespace-nowrap before:absolute before:top-3 before:left-1/2 before:h-1 before:border-l before:border-fg-3"
            :style="{ left: t.x * 100 + '%' }"
            >{{ t.label }}</span
        >
        <span
            class="absolute top-0 right-0 whitespace-nowrap before:absolute before:top-3 before:left-1/2 before:h-1 before:border-l before:border-fg-3"
            >{{ node.live ? 'now' : '' }}</span
        >
    </div>
</template>
